export const Options = {
    Salutation: [
        { text: "Weiblich", value: "Weiblich" },
        { text:"Männlich",value:"Männlich"},
        { text:"Divers",value:"Divers"}
    ],
    BecomingAwareThrough: [
        { text:"APL-Karriereseite", value:"APL-Karriereseite"},
        { text:"Karriereportale", value:"Karriereportale"},
        { text:"Social Media (z.B. Instagram)", value:"Social Media (z.B. Instagram)"},
        { text:"Business Netzwerke (z.B. LinkedIn)", value:"Business Netzwerke (z.B. LinkedIn)"},
        { text:"Messe/Veranstaltungen", value:"Messe/Veranstaltungen"},
        { text:"Schulen/Hochschulen", value:"Schulen/Hochschulen"},
        { text:"Persönliche Empfehlung", value:"Persönliche Empfehlung"},
        { text:"Ich bin APL-Mitarbeiter(in)", value:"Ich bin APL-Mitarbeiter(in)"},
        { text:"Sonstige", value:"Sonstige"},
    ]
}
